import { IPlayerState } from '../../../State/Player/IPlayerState';
import IPlayerData from '../../IPlayerData';
import { restoreString } from '../../ParseHelper';
import PlayerProperty from '../PlayerProperty';

export default class CardBackTexture extends PlayerProperty<
    string,
    {
        backcards_select: string;
    }
> {
    public readonly defaultValue: string = 'backcard_1.png';

    public restore(playerEndpointData: IPlayerData): string {
        return restoreString(
            playerEndpointData.backcards_select,
            this.defaultValue
        ).replace('.png', '');
    }

    public save(playerStateData: IPlayerState) {
        return { backcards_select: playerStateData.backcard + '.png' };
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        let cardBackTexture = playerEndpointData.backcards_select;
        if (typeof cardBackTexture === 'string') {
            cardBackTexture = cardBackTexture.replace('.png', '');
        }

        return playerStateData.backcard !== cardBackTexture;
    }
}
